import React, { MouseEvent, ReactNode, useRef } from 'react';
import styled from 'styled-components/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import cx from 'classnames';
import { Button } from './Button';

type Props = {
  children: ReactNode;
  className?: string;
  dismissWithCloseButtonOnly?: boolean;
  onClose: () => void;
};

export const Modal = (props: Props) => {
  const { className, children, dismissWithCloseButtonOnly, onClose } = props;
  const closeModal = () => onClose();
  const modal = useRef<HTMLDivElement>(null);

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    if (e.target !== modal.current || dismissWithCloseButtonOnly) return;
    closeModal();
  };

  return (
    <ModalWrapper className={cx('man-ui', className)} ref={modal} onClick={handleClick}>
      <CloseButton onClick={closeModal}>
        <FontAwesomeIcon icon={faTimes} />
      </CloseButton>
      {children}
    </ModalWrapper>
  );
};

const ModalWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 1000;
  transition: 0.3s opacity ease;
  top: 0px;
`;

export const CloseButton = styled(Button)`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  width: 35px;
  height: 35px;
  border: none;
  font-size: 1.43rem;
  outline: none;
  box-shadow: none;
`;
